import Newsletter_48_container from "./container/Newsletter_48_container";
export default Newsletter_48_container;
